var loadAsyncJS;

module.exports = loadAsyncJS = function(url) {
  var p, s;
  s = document.createElement('script');
  s.async = true;
  s.src = url;
  p = document.getElementsByTagName('script')[0];
  return p.parentNode.insertBefore(s, p);
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvbG9hZEFzeW5jSlMuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL2FyaWNodGVyL3JlcG9zaXRvcmllcy9zbHMvY29yZS9mcm9udGVuZC9ncm91cG9uX21vZHVsZXMvbG9hZEFzeW5jSlMuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNBLElBQUE7O0FBQUEsTUFBTSxDQUFDLE9BQVAsR0FBaUIsV0FBQSxHQUFjLFNBQUMsR0FBRDtBQUM3QixNQUFBO0VBQUEsQ0FBQSxHQUFJLFFBQVEsQ0FBQyxhQUFULENBQXVCLFFBQXZCO0VBQ0osQ0FBQyxDQUFDLEtBQUYsR0FBVTtFQUNWLENBQUMsQ0FBQyxHQUFGLEdBQVE7RUFDUixDQUFBLEdBQUksUUFBUSxDQUFDLG9CQUFULENBQThCLFFBQTlCLENBQXdDLENBQUEsQ0FBQTtTQUM1QyxDQUFDLENBQUMsVUFBVSxDQUFDLFlBQWIsQ0FBMEIsQ0FBMUIsRUFBNkIsQ0FBN0I7QUFMNkIifQ==
